import React from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Box
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { StyledTableCell } from './helper';

const LastComplaintsTable = ({ complaints }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleRowClick = (complaintId) => {
    navigate(`kengur2/#/complaints-admin-page`);
  };

  return (
    <Box m="20px">
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          borderRadius: '12px',
          backgroundColor: 'rgba(255, 255, 255, 0.8)'
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>{t('columns.id')}</StyledTableCell>
              <StyledTableCell>{t('columns.school')}</StyledTableCell>
              <StyledTableCell>{t('columns.student')}</StyledTableCell>
              <StyledTableCell>{t('columns.message')}</StyledTableCell>
              <StyledTableCell>{t('columns.date')}</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {complaints.map((complaint) => (
              <TableRow
                key={complaint.id}
                hover
                onClick={() => handleRowClick(complaint.id)}
                sx={{ cursor: 'pointer' }}
              >
                <TableCell>{complaint.id}</TableCell>
                <TableCell>{complaint.school_name}</TableCell>
                <TableCell>
                  {complaint.student ? complaint.student.name : ''}
                </TableCell>
                <TableCell>{complaint.poruka.slice(0, 20)}</TableCell>
                <TableCell>
                  {new Date(complaint.date * 1000).toLocaleDateString('sr-RS', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default LastComplaintsTable;
